/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */

/**
 * Sort function for date columns
 * Handles null/undefined values and invalid dates
 */
export const dateSortingFn = (rowA, rowB, columnId) => {
  const dateA = rowA.getValue(columnId);
  const dateB = rowB.getValue(columnId);

  // Handle null/undefined values - push them to the end
  if (!dateA && !dateB) return 0;
  if (!dateA) return 1;
  if (!dateB) return -1;

  // Use Date objects for comparison
  const timeA = new Date(dateA).getTime();
  const timeB = new Date(dateB).getTime();

  // Handle invalid dates
  if (Number.isNaN(timeA) && Number.isNaN(timeB)) return 0;
  if (Number.isNaN(timeA)) return 1;
  if (Number.isNaN(timeB)) return -1;

  return timeA - timeB;
};
